module.exports = __webpack_public_path__ + "img/EnerArk 2.37ef2215.svg";